import { LoaderCircle } from "lucide-react";
import type { ComponentPropsWithoutRef } from "react";

import { cn } from "@/lib/utils";

export function Spinner({
  className,
  ...props
}: ComponentPropsWithoutRef<typeof LoaderCircle>): React.JSX.Element {
  return (
    <LoaderCircle
      data-slot="spinner"
      data-icon="inline-start"
      className={cn("size-4 animate-spin", className)}
      {...props}
    />
  );
}
